const empty = () =>
  import(/* webpackChunkName: 'empty' */ "../views/Empty.vue");

export default [
  {
    path: "finance",
    name: "Finance",
    component: empty,
    children: [
      {
        path: "order",
        name: "Order",
        component: empty,
        children: [
          {
            path: "course",
            name: "OrderCourse",
            component: () =>
              import(
                /* webpackChunkName: "finance" */
                "../views/finance/Order"
              ),
            meta: {
              title: "课程订单",
              root: true,
            },
          },
          {
            path: "course-exports",
            name: "OrderCourseExports",
            component: () =>
              import(/* webpackChunkName: "finance" */ "../views/Exports"),
            meta: {
              title: "查看报表",
            },
          },
          {
            path: "exports",
            name: "Exports",
            component: () =>
              import(/* webpackChunkName: "finance" */ "../views/Exports"),
            meta: {
              title: "查看报表",
            },
          },
          {
            path: "one",
            name: "OrderOne",
            component: () =>
              import(
                /* webpackChunkName: "finance" */
                "../views/finance/Order"
              ),
            meta: {
              title: "一对一订单",
              root: true,
            },
          },
          {
            path: "one-exports",
            name: "OrderOneExports",
            component: () =>
              import(/* webpackChunkName: "finance" */ "../views/Exports"),
            meta: {
              title: "查看报表",
            },
          },
          {
            path: "member",
            name: "OrderMember",
            component: () =>
              import(
                /* webpackChunkName: "finance" */
                "../views/finance/Order"
              ),
            meta: {
              title: "会员订单",
              root: true,
            },
          },
          {
            path: "book",
            name: "OrderBook",
            component: () =>
              import(
                /* webpackChunkName: "finance" */
                "../views/finance/Order"
              ),
            meta: {
              title: "图书订单",
              root: true,
            },
          },
          {
            path: "member-exports",
            name: "OrderMemberExports",
            component: () =>
              import(/* webpackChunkName: "finance" */ "../views/Exports"),
            meta: {
              title: "查看报表",
            },
          },
          {
            path: "exercise",
            name: "OrderExercise",
            component: () =>
              import(
                /* webpackChunkName: "finance" */
                "../views/finance/Order"
              ),
            meta: {
              title: "章节练习订单",
              root: true,
            },
          },
          {
            path: "exam",
            name: "OrderExam",
            component: () =>
              import(
                /* webpackChunkName: "finance" */
                "../views/finance/Order"
              ),
            meta: {
              title: "模考订单",
              root: true,
            },
          },
          {
            path: "refund",
            name: "OrderRefund",
            component: () =>
              import(
                /* webpackChunkName: "finance" */
                "../views/finance/Order"
              ),
            meta: {
              title: "退款订单",
              root: true,
            },
          },
          {
            path: "group",
            name: "OrderGroup",
            component: () =>
              import(
                /* webpackChunkName: "finance" */
                "../views/finance/OrderGroup"
              ),
            meta: {
              title: "拼团订单",
              root: true,
            },
          },
          {
            path: "group-detail",
            name: "OrderGroupDetail",
            component: () =>
              import(
                /* webpackChunkName: "finance" */
                "../views/finance/OrderGroupDetail"
              ),
            meta: {
              title: "订单详情",
            },
          },
          {
            path: "in-group",
            name: "OrderInGroup",
            component: () =>
              import(
                /* webpackChunkName: "finance" */
                "../views/finance/OrderGroup"
              ),
            meta: {
              title: "同团订单",
            },
          },
          {
            path: "book-exports",
            name: "OrderBookExports",
            component: () =>
              import(/* webpackChunkName: "finance" */ "../views/Exports"),
            meta: {
              title: "查看报表",
            },
          },
          {
            path: "ship-imports",
            name: "OrderShipImports",
            component: () =>
              import(/* webpackChunkName: "finance" */ "../views/Imports"),
            meta: {
              title: "批量发货",
            },
          },
          {
            path: "ship",
            name: "OrderShipList",
            component: () =>
              import(
                /* webpackChunkName: "finance" */ "../views/finance/OrderShipList.vue"
              ),
            meta: {
              title: "发货单",
              root: true,
            },
          },
          {
            path: "ship/detail",
            name: "OrderShipDetail",
            component: () =>
              import(
                /* webpackChunkName: "finance" */ "../views/finance/OrderShipDetail.vue"
              ),
            meta: {
              title: "发货单详情",
            },
          },
        ],
      },
      {
        path: "bills",
        name: "bills",
        component: empty,
        children: [
          {
            path: "payments",
            name: "OrderPaymentsList",
            component: () =>
              import(
                /* webpackChunkName: "finance" */
                "../views/finance/OrderPaymentsList"
              ),
            meta: {
              title: "收款单",
              root: true,
            },
          },
          {
            path: "refund",
            name: "OrderRefundList",
            component: () =>
              import(
                /* webpackChunkName: "finance" */
                "../views/finance/OrderRefundList"
              ),
            meta: {
              title: "退款单",
              root: true,
            },
          },
        ],
      },
      {
        path: "vcurrency",
        name: "VCurrency",
        component: empty,
        children: [
          {
            path: "record",
            name: "VCurrencyRecord",
            component: () =>
              import(
                /* webpackChunkName: "finance" */
                "../views/finance/VCurrencyRecord"
              ),
            meta: {
              title: "充值记录",
              root: true,
            },
          },
          {
            path: "balance",
            name: "VCurrencyBalance",
            component: () =>
              import(
                /* webpackChunkName: "finance" */
                "../views/finance/VCurrencyBalance"
              ),
            meta: {
              title: "余额管理",
              root: true,
            },
          },
          {
            path: "detail",
            name: "VCurrencyDetail",
            component: () =>
              import(
                /* webpackChunkName: "finance" */
                "../views/finance/VCurrencyDetail"
              ),
            meta: {
              title: "查看明细",
            },
          },
        ],
      },
    ],
  },
];
